module.exports = __webpack_public_path__ + "static/turbines-703516a67af430d9b36f8d71c2dac6c1.jpeg";